<template>
  <div
    v-if="sources && dtouchWorkspace"
  >
    <stats-source
      :workspaceID="dtouchWorkspace"
      :sources="sources"
      :locale="locale"
      :onGetData="handleGetSources"
    />
    <show-access v-if="dtouchWorkspace && sources" :workspaceID="dtouchWorkspace" :sources="sources" />
  </div>
</template>
<script>
import api from '@/services/api'
import { mapState } from 'vuex'
import StatsSource from './statsSource/Index'
import ShowAccess from './showAccess/Index'
export default {
  components: {
    StatsSource,
    ShowAccess,
  },
  data: () => ({
    sources: null,
  }),
  computed: {
    ...mapState('app',['locale', 'dtouchWorkspace']),
  },
  watch: {
    dtouchWorkspace () {
      this.handleGetSources()
    },
  },
  mounted () {
    this.handleGetSources()
  },
  methods: {
    async handleGetSources () {
      try {
        this.sources = await new Promise((resolve) => api.getAllWithoutLimit ('dtouch', `v1/private/workspaces/${this.dtouchWorkspace}/access-sources/`, false)
          .then((response) => {
            response = response.map(item => {
              item.ident = {id:item.ID,name:item.Name}
              return item
            })
            resolve(response)
          }))
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
